import styled from 'styled-components';
import { Box, Flex } from '@components/layout/Grid';
import SvgLightingIcon from '@assets/LightingIcon';
import { Trans } from '@lingui/react';
import { PROGRAM_THEMES } from '@lib/constants';
import { GenericProgram } from '@gql/generated';
import { t } from '@lingui/macro';

const Duration = styled.span`
  flex-shrink: 0;
  text-wrap: nowrap;
  font-size: 11px;
  color: #1c343e;
  font-weight: 600;
  line-height: 1.2;
  text-transform: uppercase;
  border: 1px solid currentcolor;
  border-radius: 3px;
  padding: 3px 5px;
  margin-right: 24px;
`;

const Theme = styled.span`
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  color: #213e3d;
  font-weight: 600;
  margin-left: 5px;

  svg {
    margin-right: 5px;
  }

  & + &:before {
    content: '•';
    width: 5px;
    margin-right: 5px;
  }
`;

export const durations = {
  days: t`metadata.days.label`,
  weeks: t`metadata.weeks.label`,
};

type Props = {
  className?: string;
  duration: GenericProgram['duration'];
  themes: GenericProgram['themes'];
};

const ProgramDurationTheme = ({ className, duration, themes }: Props) => {
  return duration || themes?.length > 0 ? (
    <Flex
      className={className}
      flex={1}
      flexDirection={['column', 'column', 'row']}
      alignItems="flex-start"
      mb={10}
      data-testid="ProgramDurationTheme"
    >
      {duration ? (
        <Box mb={[10, 10, 0]}>
          <Duration data-testid="ProgramDurationTheme--Duration">
            {duration?.value} <Trans id={durations[duration?.unit]} />
          </Duration>
        </Box>
      ) : null}
      {themes?.length > 0 ? (
        <Flex
          alignItems="center"
          flexWrap="wrap"
          data-testid="ProgramDurationTheme--Themes"
        >
          <SvgLightingIcon />
          {themes.map(theme => {
            if (PROGRAM_THEMES[theme]) {
              return (
                <Theme key={theme} data-testid="ProgramDurationTheme--Theme">
                  <Trans id={PROGRAM_THEMES[theme]} />
                </Theme>
              );
            }
            return theme;
          })}
        </Flex>
      ) : null}
    </Flex>
  ) : null;
};

export default ProgramDurationTheme;
